import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "sf-container"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SagePay = _resolveComponent("SagePay")!

  return (_ctx.invoice)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("h2", null, " Invoice Reference: " + _toDisplayString(_ctx.invoice?.school_reference || _ctx.invoice?.reference), 1),
        _createVNode(_component_SagePay, {
          mode: 'payinvoice',
          "invoice-id": _ctx.invoiceId,
          "purchase-data": _ctx.invoice.storePurchase.purchaseData
        }, null, 8, ["invoice-id", "purchase-data"])
      ]))
    : _createCommentVNode("", true)
}